import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.featured);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              编辑团队精心挑选的高质量韩漫作品
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium no-underline whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((comic) => {
            const cat = categories.find((c) => c.slug === comic.category);
            return (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                slug={comic.slug}
                category={comic.category}
                coverImage={comic.coverImage}
                rating={comic.rating}
                views={comic.views}
                chapters={comic.chapters}
                status={comic.status}
                tags={comic.tags}
                categoryName={cat?.name}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}